/**
 * The confirmation token of an email-link letter. It arrives in the URL
 * fragment so that it reaches no access log and no Referer, and leaves the URL
 * before analytics load (the boot script in public/index.html, which this
 * mirrors). From then on it lives only in this tab's sessionStorage, which also
 * carries it across a sign-in redirect, until it has been used.
 */
export const VERIFY_EMAIL_PATH = "/verify-email";
export const VERIFY_EMAIL_TOKEN_KEY = "verify_email_token";

const TOKEN_PREFIX = "#token=";

const readStored = (): string | null => {
  try {
    return window.sessionStorage.getItem(VERIFY_EMAIL_TOKEN_KEY);
  } catch (error) {
    return null;
  }
};

/** The token for this page, stripping it from the URL if it is still there.
 *  Safe to call twice: the second call finds it in sessionStorage. */
export const takeVerifyEmailToken = (): string | null => {
  const { hash, pathname, search } = window.location;
  if (!hash.startsWith(TOKEN_PREFIX)) return readStored();

  const fromUrl = hash.slice(TOKEN_PREFIX.length);
  window.history.replaceState(window.history.state, "", `${pathname}${search}`);
  if (!fromUrl) return readStored();
  try {
    window.sessionStorage.setItem(VERIFY_EMAIL_TOKEN_KEY, fromUrl);
  } catch (error) {
    // No storage: the token still lives in the caller's state for this page.
  }
  return fromUrl;
};

export const clearVerifyEmailToken = (): void => {
  try {
    window.sessionStorage.removeItem(VERIFY_EMAIL_TOKEN_KEY);
  } catch (error) {
    // Nothing stored, then.
  }
};
